module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__panel__list__item--active-00f3f3b74bd6513f5ec43b57b880eb36.svg";